import { jsx } from "panel";
import range from "lodash/range";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { WarningEl } from "common/components/warning";
import { WarningTheme } from "common/components/warning/constants";
import { SvgIconEl } from "common/components/svg-icon";
import { CollapsibleTheme, SectionEl } from "common/components/section";
import { TextHighlightEl } from "common/components/text-highlight";
import { SpinnerEl } from "common/components/spinner";
import { QueryBlockEl } from "common/query-builder/query-block/panel";
import { SelectorType } from "common/query-builder/query-block/constants";
import { MenuType } from "common/query-builder/query-block/types";
import { TooltipEl } from "common/components/tooltip";
import { TimeQueryBlockEl } from "common/query-builder/query-block/time-menu/panel";
import { RecordingPlayerSource } from "../recording-player/types";
import { ProfileActivityPropertiesEl } from "./activity-properties";
export function template() {
  var _a, _b;
  const isLoading = this.state.loading.initial || this.state.loading.eventDefinitions || this.state.loading.propertyDefinitions;
  const userActivity = this.helpers.getUserActivityDisplay();
  const { t, print } = this.getContext(`i18n`);
  return /* @__PURE__ */ jsx("div", { sel: ".profile-activity", class: { "sidebar-mode": this.attr(`sidebar-mode`) } }, !this.attr(`sidebar-mode`) && /* @__PURE__ */ jsx("div", { sel: ".title-bar" }, /* @__PURE__ */ jsx("div", { sel: ".activity-title" }, t(`profile.activity-feed`)), /* @__PURE__ */ jsx("div", { sel: ".filters-section" }, this.helpers.isSessionRecordingEnabled() && /* @__PURE__ */ jsx(
    ButtonEl,
    {
      sel: ".control-button",
      attrs: {
        theme: ButtonTheme.Secondary,
        icon: `replay`,
        disabled: this.state.recordings.length === 0
      },
      on: { click: this.helpers.watchReplays }
    },
    t(`profile.watch-replays`),
    this.state.loading.recordings && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(
      TooltipEl,
      {
        attrs: {
          text: t(`profile.replays-loading`),
          position: `top`
        }
      }
    ), /* @__PURE__ */ jsx(SpinnerEl, null)),
    !this.state.loading.recordings && /* @__PURE__ */ jsx(
      TooltipEl,
      {
        attrs: {
          text: this.state.recordings.length === 0 ? t(`profile.replays-none`) : t(`profile.watch-replays-tooltip`),
          position: `top`
        }
      }
    )
  ), /* @__PURE__ */ jsx(
    ButtonEl,
    {
      sel: ".control-button",
      attrs: {
        theme: ButtonTheme.Secondary,
        icon: `line`
      },
      on: { click: this.helpers.viewInInsights }
    },
    t(`profile.view-in-insights`)
  ), /* @__PURE__ */ jsx(
    TimeQueryBlockEl,
    {
      maxDataHistoryDays: (_a = this.attr(`history-limit-days`)) != null ? _a : void 0,
      selected: this.state.dateRange,
      selectorType: SelectorType.Button,
      leftIcon: "calendar",
      trackName: this.helpers.REPORT_NAME,
      projectAsOfDate: (_b = this.attr(`project-as-of-date`)) != null ? _b : void 0,
      onSelect: this.helpers.handleDateRangeSelected,
      onTrack: this.helpers.handleQueryBuilderBlockTrack
    }
  ), /* @__PURE__ */ jsx(
    QueryBlockEl,
    {
      type: MenuType.Events,
      excludeCustomEvents: true,
      dataGroupId: this.attr(`data-group-id`).toString(),
      multiple: true,
      projectId: this.helpers.getProjectId(),
      selected: this.helpers.getSelectedHiddenEvents(),
      inverted: this.state.includedEvents.length > 0,
      includeHidden: true,
      selectorIcon: "eye-hide",
      selectorType: SelectorType.Button,
      showAllEvents: true,
      trackName: this.helpers.REPORT_NAME,
      workspaceId: this.helpers.getWorkspaceId(),
      onSelect: this.helpers.updateEventFilter,
      onTrack: this.helpers.handleQueryBuilderBlockTrack
    }
  ))), !this.state.error && isLoading && /* @__PURE__ */ jsx("div", { sel: ".mp-panel-section" }, range(10).map((i) => /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-header", key: i }))), this.state.error && !isLoading && /* @__PURE__ */ jsx(
    WarningEl,
    {
      attrs: {
        "body-text": `We were unable to display this user's activity due to an error. Please try again later.`,
        "header-text": `Unable to Display Activity Feed`,
        theme: WarningTheme.Error
      }
    }
  ), !this.state.error && !isLoading && /* @__PURE__ */ jsx(null, null, userActivity.length === 0 && /* @__PURE__ */ jsx("div", { sel: ".no-data-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".no-data-image" }), t(`profile.no-activity`), " (", this.state.dateRange.getDisplayText(), ")"), userActivity.length > 0 && /* @__PURE__ */ jsx(null, null, userActivity.map((dayGroup) => /* @__PURE__ */ jsx("div", { sel: ".day-header" }, /* @__PURE__ */ jsx(
    SvgIconEl,
    {
      attrs: {
        icon: `calendar`
      }
    }
  ), print(dayGroup.dayHeader), /* @__PURE__ */ jsx("div", { sel: ".day-activities" }, dayGroup.activities.map((activity) => {
    const { eventName, eventGroup } = activity;
    const { time, insertId, replayId } = eventGroup[0];
    const hasBeenRendered = this.state.renderedGroupings.has(insertId);
    return /* @__PURE__ */ jsx("div", { sel: ".activity-event-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".activity-time" }, print(this.helpers.getDisplayTime(time))), /* @__PURE__ */ jsx("div", { sel: ".activity-name" }, /* @__PURE__ */ jsx(
      SectionEl,
      {
        attrs: {
          "enable-row-click": true,
          "is-closed": true,
          theme: CollapsibleTheme.INLINE
        },
        on: {
          change: (ev) => this.helpers.handleExpandGrouping(ev, activity)
        }
      },
      /* @__PURE__ */ jsx("div", { sel: ".activity-event-title", attrs: { slot: `title` } }, eventName, eventGroup.length > 1 && /* @__PURE__ */ jsx(TextHighlightEl, { attrs: { text: eventGroup.length } }), this.helpers.isSessionRecordingEnabled() && replayId && /* @__PURE__ */ jsx(
        SvgIconEl,
        {
          attrs: { icon: `single-replay` },
          on: {
            click: (ev) => {
              ev.stopPropagation();
              this.showRecordingsWithMetadataAsync(
                [replayId],
                [this.attr(`distinct-id`)],
                RecordingPlayerSource.UsersProfile,
                !this.attr(`sidebar-mode`)
              );
            }
          }
        }
      )),
      hasBeenRendered && eventGroup.length === 1 && /* @__PURE__ */ jsx("div", { sel: ".detail-pane" }, /* @__PURE__ */ jsx(
        ProfileActivityPropertiesEl,
        {
          attrs: {
            "utc-offset": this.attr(`utc-offset`),
            "mixpanel-properties": eventGroup[0].mixpanelProperties,
            "user-defined-event-properties": eventGroup[0].userDefinedEventProperties,
            "event-name": eventName,
            time
          }
        }
      )),
      hasBeenRendered && eventGroup.length > 1 && /* @__PURE__ */ jsx("div", { sel: ".event-group-pane" }, /* @__PURE__ */ jsx(
        EventGroup,
        {
          eventGroup,
          getDisplayTime: this.helpers.getDisplayTime,
          trackCollapsibleChange: this.helpers.trackCollapsibleChange,
          utcOffset: this.attr(`utc-offset`),
          i18n: this.getContext(`i18n`)
        }
      ))
    )));
  })))), /* @__PURE__ */ jsx("div", { sel: ".activity-footer" }, /* @__PURE__ */ jsx("div", { sel: ".since-date-wrapper" }, "Since ", this.helpers.getLastVisibleFromDate()), /* @__PURE__ */ jsx("div", { sel: ".show-more-wrapper" }, this.state.loading.moreEvents ? /* @__PURE__ */ jsx(SpinnerEl, null) : this.state.enableShowMoreButton ? /* @__PURE__ */ jsx(ButtonEl, { attrs: { theme: ButtonTheme.Secondary }, on: { click: this.helpers.handleShowMore } }, t(`profile.show-more`)) : null)))));
}
function EventGroup({ eventGroup, getDisplayTime, trackCollapsibleChange, utcOffset, i18n }) {
  const { print } = i18n;
  return eventGroup.map(({ mixpanelProperties, eventDisplayName, time, userDefinedEventProperties }) => /* @__PURE__ */ jsx("div", { sel: ".grouped-event-row" }, /* @__PURE__ */ jsx("div", { sel: ".activity-ungrouped-time" }, print(getDisplayTime(time))), /* @__PURE__ */ jsx("div", { sel: ".activity-ungrouped-name" }, /* @__PURE__ */ jsx(
    SectionEl,
    {
      attrs: {
        "enable-row-click": true,
        "hide-caret": true,
        "is-closed": true,
        theme: CollapsibleTheme.INLINE
      },
      on: {
        change: (ev) => trackCollapsibleChange(ev, eventDisplayName, time, false)
      }
    },
    /* @__PURE__ */ jsx("div", { sel: ".expand-event-properties", attrs: { slot: `title` } }, eventDisplayName),
    /* @__PURE__ */ jsx("div", { sel: ".sub-event-pane" }, /* @__PURE__ */ jsx(
      ProfileActivityPropertiesEl,
      {
        attrs: {
          "utc-offset": utcOffset,
          "event-name": eventDisplayName,
          "mixpanel-properties": mixpanelProperties,
          "user-defined-event-properties": userDefinedEventProperties,
          time
        }
      }
    ))
  ))));
}
